// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildPinTransferAORPayload, buildReviewPinTransferAORPayload} from '../../shared/services/build-review-transfer-accept-reject-payload';
import {successAlertBar, warningAlertBar} from '../../../shared/services/alert-bar';
import {closeDealerRecommendationModal} from './dealer-recommendation-modal';
import {putDealerReviewTransfer} from '../../shared/repositories';
import {resetSelectedDealerRecommendations} from './dealer-recommendation';
import {translate} from '../../../shared/services/translation-service';
import {updateTransferResultsWithFacets} from './facet-updates';

export const updateReview = (dealerRecommendation, commentsDealerRecommendation) => {

    const reviewTransferRequest = buildReviewPinTransferAORPayload(dealerRecommendation, 'REVIEWED', commentsDealerRecommendation);

    return async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putDealerReviewTransfer(reviewTransferRequest);
            dispatch(closeDealerRecommendationModal());
            successAlertBar(translate('DEALER_REVIEW_REQUEST_SUCCESSFULLY'));

        } catch (error) {
        } finally {

            dispatch(updateTransferResultsWithFacets(false, 0));
            dispatch(closeDealerRecommendationModal());
            dispatch(resetSelectedDealerRecommendations());
            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

};

export const updateTransferRequest = (dealerRecommendation, commentsDealerRecommendation) => {

    const reviewTransferRequest = buildPinTransferAORPayload(dealerRecommendation, commentsDealerRecommendation);

    return async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const status = 'failed';
            const dealerRecommendationResult = await putDealerReviewTransfer(reviewTransferRequest);

            const hasRequestPartialyCompleted = dealerRecommendationResult.some(
                recommendation => recommendation.status && recommendation.status.toLowerCase() === status);

            hasRequestPartialyCompleted ? warningAlertBar(translate('DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL')) : successAlertBar(translate('DEALER_TRANSFER_REQUEST_SUCCESSFULLY'));

        } catch (error) {
        } finally {

            dispatch(closeDealerRecommendationModal());
            dispatch(updateTransferResultsWithFacets(false, 0));
            dispatch(resetSelectedDealerRecommendations());
            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/update-dealer-recommendation.js